import React, { useContext } from 'react';

import styled from '@emotion/styled';

import Table from '../../../Table/Table';
import TableHasConflictTag from '../../../Table/TableAccessories/TableHasConflictTag';
import TableScroller from '../../../Table/TableScroller';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface ExitHistoryModalProps {
  data: any;
}

const ExitHistoryModal: React.FC<ExitHistoryModalProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  return (
    <Container>
      <ModalContainer
        width={!modalContext?.showSuccessComponent ? '867px' : undefined}
        label='View Exit History'
      >
        <TableScroller>
          <Table
            className='scrollable-table'
            tableHeader={{
              'Start Date': 'startDate',
              'End Date': 'endDate',
            }}
            tableDataSourceUrl={`api/v1/dispatchers/${data?.driverId}/exit-history`}
            cellsCustomComp={{
              companyName: (
                <TableHasConflictTag
                  dataKey='startDate'
                  // totalConflictsKey='triggeredConflict'
                  isRehiredKey='rehired'
                />
              ),
            }}
            // showPaginationControl={false}
            continuousView
            standalone
          />
        </TableScroller>
      </ModalContainer>
    </Container>
  );
};

export default ExitHistoryModal;

const Container = styled.div`
  flex-direction: column;
  display: flex;
`;
